import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import CapabilitiesPage from './pages/CapabilitiesPage';
import CertificationsPage from './pages/CertificationsPage';
import Sustainability from './pages/Sustainability';
import CapabilityStatement from './pages/CapabilityStatement';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/capabilities" element={<CapabilitiesPage />} />
        <Route path="/certifications-and-codes" element={<CertificationsPage />} />
        <Route path="/sustainability" element={<Sustainability />} />
        <Route path="/capability-statement" element={<CapabilityStatement />} />
      </Routes>
    </HashRouter>
  );
}

export default App;